export default __webpack_public_path__ + "static/media/Sanka.19950bae.jpeg";